<template>
  <span 
    class="article-head__other-field article-head__other-field__identity"
    v-if="identity || space"
  >
    {{ identity }}
    <span v-if="identity && space" tabindex="-1">|</span>
    {{ space }}
  </span>
</template>

<script>
export default {
  props: {
    identity: {
      type: String,
      default: '',
    },
    space: {
      type: String,
      default: '',
    },
  }
}
</script>

<style>

</style>